import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import PageLayout from '@/components/layouts/page-layout';
import RouteTracker from '@/components/helpers/route-tracker';
import { LocaleListener } from '@/components/helpers/language-switcher/locale-listener';

const AppLayout: FC = () => (
  <>
    <RouteTracker />
    <LocaleListener />
    <PageLayout fullWidth>
      <Outlet />
    </PageLayout>
  </>
);

export default AppLayout;
